import {
  Card,
  Descriptions,
  Button,
  Tag,
  Form,
  Spin,
  message,
} from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { useLocation, useParams } from "react-router";
import { Report } from "notiflix";
import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";

import Footer from "../../../atoms/footer";
import Navbar from "../../../atoms/navbar";
import ApprovalActions from "../../../atoms/approval-actions";
import ApprovalInfo from "../../../atoms/approval-info";
import API from "../../../services";
import "./styles.css";

import HeaderFarms from "../../../utils/header_farms";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../config/api.config";
import moment from "moment";

import { requestToken } from "../../../auth/AuthServices";

const isEmpty = (v) => {
  if (v === null || v === undefined) return true;
  if (typeof v === "string" && v.trim() === "") return true;
  if (Array.isArray(v) && v.length === 0) return true;
  return false;
};

const SECTION_HEAD_STYLE = {
  background: "#fce8b6",
  fontWeight: 600,
  fontSize: 13,
};

const DESC_LABEL_STYLE = {
  width: 130,
  fontWeight: 500,
  color: "#595959",
  background: "#fafafa",
  whiteSpace: "nowrap",
};

const DESC_CONTENT_STYLE = {
  wordBreak: "break-word",
};

function ViewSR() {
  const [form] = Form.useForm();

  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();

  const [applications, setApplications] = useState([]);
  const [completeLoadSR, setcompleteLoadSR] = useState(null);

  const { id } = useParams();
  const location = useLocation();

  const isApproveMode = location.pathname.startsWith("/wf/");
  const backNavigate = isApproveMode ? "/wf/pending" : "/sr/history";

  const getDetailSR = (token) => {
    API.SRView(HeaderFarms(token), id)
      .then((res) => {
        const data = res.data;
        data.nik = data.employee_id || data.nik;
        setcompleteLoadSR(data);
      })
      .catch((err) => {
        console.error(err);
        Report.info("Service Request", "Sorry, Service Request not found", "Okay");
      });
  };

  const getApplications = (token) => {
    API.getApplications(HeaderFarms(token), null)
      .then((res) => {
        const DTO = (res.data ?? []).map((i) => ({
          id: i.app_id,
          name: i.name,
        }));
        setApplications(DTO);
      })
      .catch((err) => {
        console.log(err);
        message.warning("Terjadi Kesalahan saat load data application");
      });
  };

  function handleLogin(instance) {
    instance.loginRedirect(loginRequest).catch((e) => console.error(e));
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const accessToken = await requestToken();
        await Promise.all([
          getDetailSR(accessToken),
          getApplications(accessToken),
        ]);
      } catch (error) {
        handleLogin(instance);
        console.error(error);
      }
    };
    fetchData();
  }, [isAuthenticated]);

  const systemNames = useMemo(() => {
    if (!completeLoadSR) return [];
    const ids = completeLoadSR.system_request ?? [];
    return ids
      .map((sid) => applications.find((a) => a.id === sid)?.name || sid)
      .filter(Boolean);
  }, [completeLoadSR, applications]);

  const renderTagList = (items) => (
    <span>
      {items.map((it, idx) => (
        <Tag key={idx} style={{ marginBottom: 4 }}>
          {it}
        </Tag>
      ))}
    </span>
  );

  const renderSection = (title, items, columns = 2) => {
    const filtered = items.filter((i) => !isEmpty(i.value));
    if (filtered.length === 0) return null;

    return (
      <Card
        size="small"
        title={title}
        style={{ marginBottom: 12 }}
        headStyle={SECTION_HEAD_STYLE}
        bodyStyle={{ padding: 0 }}
      >
        <Descriptions
          size="small"
          bordered
          column={columns}
          labelStyle={DESC_LABEL_STYLE}
          contentStyle={DESC_CONTENT_STYLE}
        >
          {filtered.map((i) => (
            <Descriptions.Item key={i.label} label={i.label}>
              {i.value}
            </Descriptions.Item>
          ))}
        </Descriptions>
      </Card>
    );
  };

  if (!completeLoadSR) {
    return (
      <>
        <Navbar
          title="View"
          back={true}
          subtitle="Service Request"
          navigate={backNavigate}
        />
        <div className="container-fluid white-back-cr sr-view">
          <div className="text-center" style={{ padding: 60, color: "#B7B7B7" }}>
            <Spin size="large" />
          </div>
        </div>
        <Footer />
      </>
    );
  }

  const status = completeLoadSR.approval_process_id.data.status;
  const statusTagColor =
    status === "Approved" ? "blue" :
      status === "Waiting Approval" ? "orange" :
        status === "Closed" ? "green" :
          status === "Reject" ? "red" :
            status === "Cancel" ? "default" : "default";

  const userItems = [
    { label: "Fullname", value: completeLoadSR.fullname },
    { label: "NIK", value: completeLoadSR.nik },
    { label: "Position", value: completeLoadSR.position },
    { label: "Department", value: completeLoadSR.department },
    { label: "Business Unit", value: completeLoadSR.company },
    { label: "Phone", value: completeLoadSR.phone_number },
    { label: "Employee Status", value: completeLoadSR.employee_status },
  ];

  const equipmentItems = [
    { label: "Type of Request", value: completeLoadSR.type_request },
    { label: "Type Explain", value: completeLoadSR.type_request_explain },
    { label: "Equipment", value: completeLoadSR.equipment_details },
    { label: "Equipment Other", value: completeLoadSR.equipment_details_explain },
  ];

  const droneItems = [
    { label: "Area", value: completeLoadSR.drone_area },
    {
      label: "Tanggal & Jam",
      value: completeLoadSR.drone_request_at
        ? moment(completeLoadSR.drone_request_at).format("LLL")
        : null,
    },
  ];

  const systemItems = [
    {
      label: "Account",
      value: !isEmpty(completeLoadSR.account_request) ? renderTagList(completeLoadSR.account_request) : null,
    },
    { label: "Account Other", value: completeLoadSR.account_request_other },
    {
      label: "System",
      value: !isEmpty(systemNames) ? renderTagList(systemNames) : null,
    },
    { label: "System Other", value: completeLoadSR.system_request_other },
    { label: "Justification", value: completeLoadSR.justification },
  ];

  const networkItems = [
    { label: "Login Name", value: completeLoadSR.login_name },
    { label: "Email Address", value: completeLoadSR.email_address },
    { label: "Network Folder", value: completeLoadSR.network_folder },
    {
      label: "Permissions",
      value: !isEmpty(completeLoadSR.permission_network_folder)
        ? renderTagList(completeLoadSR.permission_network_folder)
        : null,
    },
    {
      label: "Communication Access",
      value: !isEmpty(completeLoadSR.communication_access)
        ? renderTagList(completeLoadSR.communication_access)
        : null,
    },
  ];

  const descriptionItems = [
    { label: "Description", value: completeLoadSR.description },
  ];

  return (
    <>
      <Navbar
        title="View"
        back={true}
        subtitle="Service Request"
        navigate={backNavigate}
      />
      <div className="container-fluid white-back-cr sr-view">
        <Form form={form} layout="vertical">
          <div className="container py-3">
            <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
              <Button
                type="primary"
                icon={<PrinterOutlined />}
                onClick={() => window.open(`/sr/print/${id}`, "_blank")}
              >
                Print
              </Button>
            </div>

            <Card
              size="small"
              title="Service Request Information"
              style={{ marginBottom: 12 }}
              headStyle={SECTION_HEAD_STYLE}
            >
              <Descriptions
                size="small"
                bordered
                column={1}
                labelStyle={DESC_LABEL_STYLE}
                contentStyle={DESC_CONTENT_STYLE}
              >
                <Descriptions.Item label="Form ID">
                  {completeLoadSR.form_record}
                </Descriptions.Item>
                <Descriptions.Item label="Status">
                  <Tag color={statusTagColor} style={{ fontSize: 12, fontWeight: 600 }}>
                    {status}
                  </Tag>
                </Descriptions.Item>
                <Descriptions.Item label="Created at">
                  {moment(completeLoadSR.created_at).format("LLL")}
                </Descriptions.Item>
              </Descriptions>

            </Card>

            <Card
              size="small"
              style={{ marginBottom: 12 }}
              bodyStyle={{ padding: 12 }}
            >
              <ApprovalInfo documentData={completeLoadSR} usePanel={false} />
            </Card>

            {renderSection("User Requiring Access", userItems, { xs: 1, sm: 2, md: 3 })}
            {renderSection("Equipment Request", equipmentItems, { xs: 1, sm: 2 })}
            {renderSection("Drone Request", droneItems, { xs: 1, sm: 2 })}
            {renderSection("System Request", systemItems, 1)}
            {renderSection("Network Access and Communication Request", networkItems, { xs: 1, sm: 2 })}
            {renderSection("Description", descriptionItems, 1)}
          </div>

          <ApprovalActions mainData={completeLoadSR} />
        </Form>
      </div>
      <Footer />
    </>
  );
}

const reduxState = (state) => ({
  getUser: state.initializeTicket,
});

export default connect(reduxState, null)(ViewSR);
